import React from "react";
import PropTypes from "prop-types";

class Scrubber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tempHandle: undefined,
      currentScrubber: undefined
    };

    this.currentScrubberRef = React.createRef();

    this._mouseMove = this._mouseMove.bind(this);
    this._calleeMouseUp = this._calleeMouseUp.bind(this);
    this._startDrag = this._startDrag.bind(this);
    this._scrubberTap = this._scrubberTap.bind(this);
  }

  _mouseMove(e) {
    e = Fraction.Helpers.normalEvent(e);
    const curX = e.clientX;
    const dist = Math.min(
      100,
      ((curX - this.state.currentScrubber.offset().left) /
        this.state.currentScrubber.width()) *
        100.0
    );
    this.setState({ tempHandle: dist });
    this.props.mouseMoveEvent(dist);
  }

  _calleeMouseUp(e) {
    e.stopPropagation();
    e = Fraction.Helpers.normalEvent(e);
    Fraction.Helpers.uncoverReader();
    $(window).unbind(Fraction.Helpers.mouseMoveEvent, this._mouseMove);
    $(window).unbind(Fraction.Helpers.mouseUpEvent, this._calleeMouseUp);

    if (this.state.tempHandle) {
      this.props.endDragEvent(this.state.tempHandle);
    } else {
      this._scrubberTap(e);
    }
    setTimeout(() => {
      this.setState({ tempHandle: false });
    }, 2000);
  }

  _startDrag(e) {
    e.stopPropagation();
    e = Fraction.Helpers.normalEvent(e);
    Fraction.Helpers.coverReader();
    this.setState({
      currentScrubber: $(this.currentScrubberRef.current)
    });
    $(window).bind(Fraction.Helpers.mouseMoveEvent, this._mouseMove);
    $(window).bind(Fraction.Helpers.mouseUpEvent, this._calleeMouseUp);
  }

  _scrubberTap(e) {
    e = Fraction.Helpers.normalEvent(e);
    var curX = e.clientX;
    var dist = Math.min(
      100,
      ((curX - $(this.currentScrubberRef.current).offset().left) /
        $(this.currentScrubberRef.current).width()) *
        100.0
    );
    this.setState({ tempHandle: dist });
    this.props.endDragEvent(dist);
  }

  render() {
    const progress = {
      width: (this.state.tempHandle || this.props.progress) + "%"
    };
    const scrubberWidth = this.props.buttonNumber
      ? { right: this.props.buttonNumber * 57 + "px" }
      : { right: Fraction.Helpers.isSmallScreen() ? "15px" : "275px" };
    return (
      <div
        id="scrubber"
        ref={this.currentScrubberRef}
        className="no-highlight expanded"
        onMouseDown={this._startDrag}
        style={scrubberWidth}
        role="slider"
        aria-label={i18n.t("reader.scrubber.book-progression")}
        aria-valuemin="0"
        aria-valuemax="100" 
        aria-valuenow={this.props.progress}
        aria-valuetext={i18n.t("reader.scrubber.page-number-value" , { number: this.props.pageNumber })}
        tabIndex={0}
      >
        <div id="progress" style={progress}>
          <div
            id="handle"
            className={this.state.tempHandle ? "grabbed" : ""}
            onMouseDown={this._startDrag}
            onTouchStart={this._startDrag}
          >
            <div className="overhandle no-highlight" />
          </div>
        </div>
      </div>
    );
  }
}

Scrubber.propTypes = {
  mouseMoveEvent: PropTypes.func,
  endDragEvent: PropTypes.func,
  progress: PropTypes.number,
  pageNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Scrubber.defaultProps = {
  progress: 0
};

module.exports = Scrubber;
